import React, { useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Adm from './components/adm';
import { link } from './utils/link';
import { smooth } from './utils/smooth';

import HomeView from './views/HomeView';
const App = () => {
  useEffect(() => {
    console.log(
      '%c MOSU Seoul ',
      "font-family: 'Courier New', monospace; font-size: 20px; font-weight: bold; color: #333; background: #f5f5f5; padding: 8px 16px; border: 2px solid #333; border-radius: 4px; text-transform: uppercase;"
    );

    console.log('Create by @YaongPainter');

    smooth();
    link();

    // iOS Safari 뷰포트 높이 설정 (모바일 기기에서만 적용)
    // 모바일 기기 감지: 터치 이벤트 지원 및 화면 너비 체크
    const isMobileDevice = () => {
      return (
        'ontouchstart' in window ||
        navigator.maxTouchPoints > 0 ||
        (window.innerWidth <= 800 && window.matchMedia('(pointer: coarse)').matches)
      );
    };

    if (isMobileDevice()) {
      // restaurant-mingles.com 방식 참고: visualViewport 우선 사용
      const setViewportHeight = () => {
        // visualViewport가 있으면 우선 사용 (주소창 변화 정확히 감지)
        const height = window.visualViewport 
          ? window.visualViewport.height 
          : window.innerHeight;
        const vh = height * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`, 'important');
      };
      
      // 초기 설정 (약간의 딜레이로 확실하게)
      setTimeout(() => {
        setViewportHeight();
      }, 0);
      
      // 모든 이벤트에 대응
      const updateViewport = () => {
        setViewportHeight();
      };
      
      window.addEventListener('resize', updateViewport);
      window.addEventListener('orientationchange', updateViewport);
      
      // visualViewport API 이벤트 (iOS Safari 주소창 변화 대응) - 우선순위 높음
      if (window.visualViewport) {
        window.visualViewport.addEventListener('resize', updateViewport);
        window.visualViewport.addEventListener('scroll', updateViewport);
      }
      
      // 스크롤 시 즉시 업데이트 (iOS Safari 주소창 변화 대응)
      let lastScrollY = window.scrollY;
      let lastInnerHeight = window.innerHeight;
      let scrollTimeout;
      
      const handleScroll = () => {
        const currentScrollY = window.scrollY;
        const currentInnerHeight = window.innerHeight;
        
        // 스크롤을 위로 올릴 때 (주소창이 나타날 때) 즉시 업데이트
        if (currentScrollY < lastScrollY || currentScrollY === 0) {
          // 주소창이 나타나는 시점이므로 즉시 업데이트
          requestAnimationFrame(() => {
            setViewportHeight();
          });
        } else if (currentInnerHeight !== lastInnerHeight) {
          // 뷰포트 높이가 변했을 때도 즉시 업데이트
          requestAnimationFrame(() => {
            setViewportHeight();
          });
        } else {
          // 아래로 스크롤할 때는 약간의 딜레이
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => {
            setViewportHeight();
          }, 50);
        }
        
        lastScrollY = currentScrollY;
        lastInnerHeight = currentInnerHeight;
      };
      
      window.addEventListener('scroll', handleScroll, { passive: true });
      
      // 터치 이벤트에서도 업데이트
      window.addEventListener('touchmove', updateViewport, { passive: true });
      const handleTouchEnd = () => {
        // 터치 종료 시 즉시 업데이트 (주소창 변화 대응)
        requestAnimationFrame(() => {
          setViewportHeight();
        });
      };
      window.addEventListener('touchend', handleTouchEnd, { passive: true });
      
      // 주기적으로 뷰포트 높이 체크 (더 자주)
      const viewportCheckInterval = setInterval(() => {
        setViewportHeight();
      }, 50);

      return () => {
        window.removeEventListener('resize', updateViewport);
        window.removeEventListener('orientationchange', updateViewport);
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('touchmove', updateViewport);
        window.removeEventListener('touchend', handleTouchEnd);
        if (window.visualViewport) {
          window.visualViewport.removeEventListener('resize', updateViewport);
          window.visualViewport.removeEventListener('scroll', updateViewport);
        }
        clearInterval(viewportCheckInterval);
      };
    }

    // PC에서는 cleanup 함수가 필요 없지만, useEffect는 항상 함수를 반환해야 함
    return () => {};
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeView />} />
        <Route path="/adm" element={<Adm />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
